/* eslint-disable */
import React, { Component } from 'react';
import { Link, NavLink, withRouter } from 'react-router-dom';
import classnames from 'classnames';
import qs from 'qs';
import * as styles from './navBar.module.scss';
import _ from 'lodash'
console.log('styles=======',styles)
class NavBar extends Component {
  constructor(props) {
    super(props)

    var color = 'black'

    this.state = {
      showActionbar: false,
      showAllNav: false,
      titleColor: color
    }
  }

  goBack = evt => {

    evt.preventDefault();

    const { location } = this.props;
    const closeWindow = window.location.hash === '#pure';


    const via = window.sessionStorage.getItem('via');
    const nativeUrl = window.sessionStorage.getItem('native_url', location.href);
    if (via === 'native_home' && window.orbitBridge && window.location.href === nativeUrl) {
      window.orbitBridge.invoke({
        method: 'goBackToNative'
      });
      return;
    }
    if (!closeWindow) {
      return this.props.history.goBack();
    }
  }

  //just for Android
  showMenu = evt => {
    evt.preventDefault();
    const userAgent = window.navigator.userAgent;
    if(!this.isAndroid(userAgent)) {
      return
    }
    window.orbitBridge.invoke({
      method: "toggleNavbar",
      params: {
        show: true,
      },
      error: function (err) {
        console.error('error:', err);
      },
      success: function (result) {
        console.log('result:', result);
      }
    });
  }

  toggleActionbar = event => {
    this.setState({
      showActionbar: !this.state.showActionbar
    })
  }

  toggleAllNav = () => {
    const { parents } = this.props
    if(!parents || parents.length === 0) {
      return
    }
    this.setState({
      showAllNav: !this.state.showAllNav
    })
  }

  btnOnClick = btn => event => {
    this.toggleActionbar()
    btn.onClick(event);
  }

  renderButtons() {
    const { buttons } = this.props
    const { titleColor } = this.state

    return buttons.map((btn, i) => (

      btn.renderBtn ? btn.renderBtn(this.state, this.props)
      :
      <div
        key={i}
        onClick={this.btnOnClick(btn)}
        className={classnames(styles?.btn, btn.isActive && styles?.active)}>
        <i className={classnames('iconfont', styles?.icon)} style={{ color: btn.isActive && titleColor }}>{btn.icon}</i>
        <span className={styles?.label}>{btn.label}</span>
      </div>
    ));
  }

  onShareClick = event => {
    this.toggleActionbar();
    this.props.onShareClick ? this.props.onShareClick(event) : null;
  }
  onCollectionClick = event => {
    this.toggleActionbar();
    this.props.onCollectionClick ? this.props.onCollectionClick(event) : null;
  }

  componentDidMount() {

  }

  isAndroid = (userAgent) => {
    if (userAgent && (userAgent.includes('Android') || userAgent.includes('Adr')) && window.orbitBridge) {
      return true
    }
    return false
  }

  widthUpdate = () => {
   
  }

  render() {
    const { title, parents, user, buttons } = this.props
    const { showActionbar, showAllNav, titleColor } = this.state

    const userAgent = window.navigator.userAgent;
    const screen = window.screen;
    // 默认高度是 50
    let height = 50;
    let top = 0;
    // 以下的设配只有在客户端才需要
    if (window.orbitBridge) {
      if (userAgent.includes('iPhone') || userAgent.includes('iPad')) {
        // 如果是 iPhone 或 iPad 就是 64
        height = 64;
        top = 20;
        if (screen.height === 812 || screen.height === 896) {
          // 如果是 iPhone X，那就是 88
          height = 88;
          top = 44;
        }
      }
    }
    const query = qs.parse(location.search.slice(1))
    if (query.via === 'native_home') {
      window.sessionStorage.setItem('via', 'native_home');
      // 用来标识要返回的 url 地址
      window.sessionStorage.setItem('native_url', location.href);
    }
    const hideBack = !parents || parents.length == 0 || false
    const via = window.sessionStorage.getItem('via');
    const bgColor = _.get(this.props.layout, 'config.general.ui.breadcrumbBackgroundColor', null)

    return (
      <div id='head' className={classnames(styles?.navBar, this.props.className)} style={{ height: `${height}px`, backgroundColor: bgColor && bgColor,width:'100%' }}>
        {
          (via === 'native_home' && window.orbitBridge)
            ?
            <div className={styles?.container} style={{ height: `${height === 50 ? 50 : 44}px` }}>
              <Link to="/" onClick={this.goBack} className={styles?.nativeBackBtn}>
                <i className={classnames('iconfont', styles?.icon)} style={{ color: titleColor }}>&#xe64b;</i>
              </Link>
              <div
                className={classnames(styles?.navigator)}
                style={{ height: `${height === 50 ? height : height - top}px`, top: `${top}px` }}>
                <span
                  className={styles?.nav} style={{ color: titleColor, marginTop: `${height === 50 ? height - 44 : 0}px` }}>
                  {title && title.length > 10 ? title.substring(0, 10) + '...' : title}
                </span>
              </div>
              <div className={styles?.actionBar}>
                {
                  ((buttons && buttons.length > 0) || this.props.onCollectionClick || this.props.onShareClick) && (
                    <div className={styles?.moreBtn} onClick={()=>{
                      console.log('onClick--->>>');
                      this.props.onMoreBtnClickHook && this.props.onMoreBtnClickHook()
                      this.toggleActionbar && this.toggleActionbar();
                    }}>
                      <i className={classnames('iconfont', styles?.icon)}>&#xe6b3;</i>
                    </div>)
                }
                <div className={classnames(styles?.overlay, showActionbar && styles?.show)} onClick={this.toggleActionbar} />
                <div
                  ref="actionBar"
                  className={classnames(styles?.wrap, !showActionbar && styles?.hide)}>
                  {
                    this.renderButtons()
                  }
                  {
                    this.props.onCollectionClick && (window.orbitBridge || user) ?
                      <div className={classnames(styles?.btn, styles?.addBtn)} onClick={this.onCollectionClick}>
                        <i className={classnames('iconfont', styles?.icon)}>&#xe674;</i>
                        <span className={styles?.label}>{getString('PAGE_ADD', '收藏此页面')}</span>
                      </div>
                      : null
                  }
                  {
                    this.props.onShareClick ?
                      <div className={classnames(styles?.btn, styles?.shareBtn)} onClick={this.onShareClick}>
                        <i className={classnames('iconfont', styles?.icon)}>&#xe671;</i>
                        <span className={styles?.label}>{getString('PAGE_SHARE', '分享此页面')}</span>
                      </div>
                      : null
                  }

                </div>
              </div>
            </div>
            :
            <div className={styles?.container} style={{ height: `${height === 50 ? 50 : 44}px` }}>
              <Link to="/" onClick={!hideBack ? this.goBack : this.showMenu} className={!hideBack ? styles?.backBtn : styles?.cus_backBtn}>
                {
                  !hideBack
                  ?
                  <i className={classnames('iconfont', styles?.icon)} style={{ color: titleColor }}>&#xe64b;</i>
                  :
                  (
                  this.isAndroid(userAgent)
                  ?
                  <img style={{width: 25}} src={process.env.PUBLIC_PATH + '/static/home_menu.png'} alt="home" />
                  :
                  null
                  )
                }
                </Link>
              <div
                style={{ height: showAllNav ? `${(height === 50 ? height : height - top) + parents.length * 44}px` : `${height === 50 ? height : height - top}px`, top: `${top}px` }}
                className={classnames(styles?.navigator, showAllNav && styles?.showAll)}>
                {
                  showAllNav && (
                    <div className={styles?.overlay} onClick={this.toggleAllNav} />
                  )
                }
                {
                  parents.map(p => (
                    <Link
                      to={p.to}
                      key={p.to}
                      style={{ color: titleColor,textDecoration:'none' }}
                      className={classnames(styles?.nav, !showAllNav && styles?.hide)}>
                      {p.name?.length > 10 ? p.name.substring(0, 10) + '...' : p.name}
                    </Link>
                  ))
                }
                {
                  title && (
                    <span
                      className={classnames(styles?.nav, hideBack ? styles?.current_home : styles?.current, showAllNav && styles?.expand)}
                      style={{ color: titleColor }}
                      onClick={this.toggleAllNav}>
                      {title && title.length > 10 ? title.substring(0, 10) + '...' : title}
                    </span>
                  )
                }
              </div>
              <div className={styles?.actionBar}>
                {
                  ((buttons && buttons.length > 0) || this.props.onCollectionClick || this.props.onShareClick) && (
                    <div className={styles?.moreBtn} onClick={()=>{
                      console.log('onClick--->>>');
                      this.props.onMoreBtnClickHook && this.props.onMoreBtnClickHook()
                      this.toggleActionbar && this.toggleActionbar();
                    }}>
                      <i className={classnames('iconfont', styles?.icon)}>&#xe6b3;</i>
                    </div>)
                }
                <div className={classnames(styles?.overlay, showActionbar && styles?.show)} onClick={this.toggleActionbar} />
                <div
                  ref="actionBar"
                  className={classnames(styles?.wrap, !showActionbar && styles?.hide)}>
                  {
                    this.renderButtons()
                  }
                  {
                    this.props.onCollectionClick && (window.orbitBridge || user) ?
                      <div className={classnames(styles?.btn, styles?.addBtn)} onClick={this.onCollectionClick}>
                        <i className={classnames('iconfont', styles?.icon)}>&#xe674;</i>
                        <span className={styles?.label}>{getString('PAGE_ADD', '收藏此页面')}</span>
                      </div>
                      : null
                  }
                  {
                    this.props.onShareClick ?
                      <div className={classnames(styles?.btn, styles?.shareBtn)} onClick={this.onShareClick}>
                        <i className={classnames('iconfont', styles?.icon)}>&#xe671;</i>
                        <span className={styles?.label}>{getString('PAGE_SHARE', '分享此页面')}</span>
                      </div>
                      : null
                  }
                </div>
              </div>
            </div>
        }
      </div>
    )
  }
}

NavBar.defaultProps = {
  title: null,
  parents: [],
  buttons: []
}

export default withRouter(NavBar);
